import React from 'react';
import PropTypes from 'prop-types';
import {
    Flex,
    Text,
    Box,
    Image,
    Icon as FigmaIcon,
    Popover,
    PopoverContent,
    PopoverTrigger,
} from '@spothero/ui';
import IconInfoCircle from '@spothero/icons/info';
import {VISUAL_FLAG_TYPES} from 'utils/visual-flags';

const styling = ({isDetails, isMultiday}) => {
    const imageHeightWidth = isDetails ? (isMultiday ? 7 : 10) : 4;
    const textMarginLeft = 1.5;
    const textColor = 'gray.dark';

    return {
        parent: {
            alignItems: 'center',
            marginBottom: 4,
        },
        image: {
            maxHeight: imageHeightWidth,
            maxWidth: imageHeightWidth,
        },
        title: {
            marginLeft: textMarginLeft,
            variant: isDetails ? 'body' : 'caption',
            fontWeight: isDetails
                ? isMultiday
                    ? 'semibold'
                    : null
                : 'semibold',
            color: textColor,
            display: 'inline-block',
        },
        icon: {
            fontSize: 'sm',
            display: 'inline-block',
            marginLeft: 2,
            color: 'primary.default',
            verticalAlign: 'revert',
        },
        popoverContent: {
            outline: '0',
            fontWeight: 'normal',
            variant: 'dark',
            zIndex: 'layer1',
        },
        description: {
            marginLeft: textMarginLeft,
            variant: 'caption',
            color: textColor,
        },
    };
};

export const OfficialParking = ({
    icon,
    title,
    description,
    isDetails,
    type,
}) => {
    const genericTestId = `${type}${isDetails ? '-detail' : ''}`;
    const isMultiday = type === VISUAL_FLAG_TYPES.MULTI_DAY;
    const stylingValues = styling({isDetails, isMultiday});

    return (
        <Flex {...stylingValues.parent} data-testid={genericTestId}>
            <Image
                src={
                    !icon || icon === 'https://res.cloudinary.com/spothero/'
                        ? '/img/official-icon.png'
                        : icon
                }
                {...stylingValues.image}
                data-testid={`${genericTestId}-flair`}
            />
            <Box>
                <Text
                    {...stylingValues.title}
                    data-testid={`${genericTestId}-title`}
                >
                    {title}
                </Text>
                {isDetails &&
                    (isMultiday ? (
                        <Popover zIndex="layer1">
                            <PopoverTrigger>
                                <FigmaIcon
                                    alt="Info Circle Icon"
                                    as={IconInfoCircle}
                                    data-testid={`${genericTestId}-description-button`}
                                    {...stylingValues.icon}
                                />
                            </PopoverTrigger>

                            <PopoverContent
                                {...stylingValues.popoverContent}
                                data-testid={`${genericTestId}-description-popup`}
                                hideCloseButton
                            >
                                {description}
                            </PopoverContent>
                        </Popover>
                    ) : (
                        <Text
                            {...stylingValues.description}
                            data-testid={`${genericTestId}-description`}
                        >
                            {description}
                        </Text>
                    ))}
            </Box>
        </Flex>
    );
};

OfficialParking.propTypes = {
    icon: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    isDetails: PropTypes.bool,
    type: PropTypes.string,
};
